// SEC-06. There are ~580 console calls in this app, and the audit found some of them
// printing a plaintext password, a new password and its confirmation, the whole login
// response including the JWT, and client PII. Those individual lines are removed; this is
// the backstop for everything that is left, and for whatever gets added next.
//
// WHY A RUNTIME SHIM RATHER THAN STRIPPING AT BUILD TIME
// Create React App does not allow a custom Babel or Terser config without ejecting, and
// adding craco or react-app-rewired to strip console calls means changing how every
// deploy builds — too much risk for this task. This costs a few bytes, keeps the calls in
// the bundle, and makes them silent in production, which is the part that matters for
// somebody reading a customer's screen or a support screenshot.
//
// warn and error stay: they are what makes a real fault visible, and they do not carry
// payloads in this codebase. Anything genuinely worth keeping should be console.warn.
//
// It runs ON IMPORT, at module-evaluation time, and is the first import in src/index.js.
// That matters: ES imports are hoisted, so a silence...() CALL placed at the top of
// index.js would still run after every imported module had already been evaluated — and
// several of them log while evaluating.
const NOISY = ["log", "debug", "info", "trace", "table", "dir", "group", "groupCollapsed"];

export const silenceConsoleInProduction = (env = process.env.NODE_ENV, target = window.console) => {
  if (env !== "production" || !target) return false;
  const noop = () => {};
  NOISY.forEach((method) => {
    if (typeof target[method] === "function") target[method] = noop;
  });
  return true;
};

// Applied on import. The function stays exported so a test can drive it with an explicit
// env and console, rather than depending on how this module was loaded.
silenceConsoleInProduction();

export default silenceConsoleInProduction;
